
import React, {useEffect, useState} from 'react';

import LoftyCarousel from 'react-multi-carousel';
import 'react-multi-carousel/lib/styles.css';

import {
} from '../../api/methodPayment.api';

import {connect} from 'react-redux';
import toastr from 'toastr';
import html2pdf from 'html2pdf.js';
import LoftyDropdownComponent from '../../components/loftydropdowncomponent';
import LoftyCountDown from '../../components/loftycountdown';
import LoftyCartCarousel from '../../components/loftycartcarousel';
import LoftyThreeCarousel from '../../components/loftythreecarousel';
import LoftyCarouselPlugin from '../../components/LoftyCarouselPlugin';
import LoftyLeaftMap from '../../components/loftyLeaftMaps';
import LoftyAnimatedParticleBackground from '../../components/loftyAnimatedParticleBackground';
import LoftyGoogleLoginComponent from '../../components/loftyGoogleLoginComponent';

import { addLoftyToken, deleteLoftytoken } from '../../actions/auth.actions';

import {getOneinmuebles5x55o } from '../../api/inmuebles5x55o.api'
import {customlistadodeimagenesdeinmuebleu092u_67c86a7fa9c8dc86c6729880 } from '../../api/imagenesdeinmuebles087wq.api'

import './visualizacininmuebleqn2py.scss';


// Hamburger
function loftyInitHam() {
  try {
  // eslint-disable-next-line no-restricted-globals
    window.addEventListener('click', (event) => {
      let originPointLeft = '';
      const comp = event.target.className;
      if (comp.includes('menu__btn') || comp.includes('span_middle') || comp.includes('span_before') || comp.includes('span_after')) {
        const res = Array.from(document.getElementsByClassName('menu__box'));
        const spanData = Array.from(document.getElementsByClassName('menu__btn'));
        const closeBtn = Array.from(document.getElementsByClassName('menu__close__btn'));
        spanData.forEach((item) => {
          originPointLeft = item.style.left;
        });
        res.forEach((item) => {
          item.style.left = '0px';
        });
        spanData.forEach((item) => {
          item.style.left = '-300px';
        });
        closeBtn.forEach((item) => {
          item.style.left = '10px';
        });
      } else {
        if (comp === 'menu__box') {
          return;
        }
        if (comp === 'linkshref') {
          return;
        }
        if (comp === 'menu__item') {
          return;
        }
        const res = Array.from(document.getElementsByClassName('menu__box'));
        const spanData = Array.from(document.getElementsByClassName('menu__btn'));
        const closeBtn = Array.from(document.getElementsByClassName('menu__close__btn'));
        res.forEach((item) => {
          item.style.left = '-300px';
        });
        spanData.forEach((item) => {
          item.style.left = originPointLeft;
        });
        closeBtn.forEach((item) => {
          item.style.left = '-100%';
        });
      }
    });
  } catch (error) {
    // console.log(error);
  }
}    
    






const Pvisualizacininmuebleqn2py = ({
  match,
  history,
  loftytoken,
  loftyuser,
  addLoftyUserApp,
  deleteLoftytokenApp,
  addLoftyTokenApp,
  
}) => {

	const [loftyendpoint_67c87871a9c8dc86c6729cbc, setLoftyEndpoint_67c87871a9c8dc86c6729cbc] = useState({});
		const [loftyres_67c86a7fa9c8dc86c6729880_component_ib5nvf, setloftyres_67c86a7fa9c8dc86c6729880_component_ib5nvf] = useState([]);


useEffect(() => {
		const loftyHandleData = async () => {
			const loftyres_67c87871a9c8dc86c6729cbc = await getOneinmuebles5x55o({ _id: match.params.id, token: loftytoken || 'asdsa' });
			setLoftyEndpoint_67c87871a9c8dc86c6729cbc(loftyres_67c87871a9c8dc86c6729cbc.data);
		}
		loftyHandleData();
	}, []);

	useEffect(() => {
		const handleLoftyData = async () => {
			try {
				const responseLoftyApps = await customlistadodeimagenesdeinmuebleu092u_67c86a7fa9c8dc86c6729880({
					inmueblep8cx5: match.params.id,
				});
				setloftyres_67c86a7fa9c8dc86c6729880_component_ib5nvf(responseLoftyApps.data);
			} catch (loftyerror) {
			}
		}
		handleLoftyData();
	}, []);



  
  setTimeout(() => { loftyInitHam(); }, 2000);

  
  

  
  return (
    <div id="id6772da6fdf08e4838cb896bc" >

      <div id="iw4j" className="">
      
      <div id="i7iuy6" className="">
      
      <div id="ikooaf" className="">
      
      <span className="material-icons " id="iv5d9d">
        
      <span className="material-icons " id="iqcwn3">
        <>call</>
      </span>
      
      </span>
      
      <div className="" id="iwehdy">
        
      <span className="" id="">
        
      </span>
      
      <span className="" id="">
        
      </span>
      
      <span className="" id="ijj06m">
        <>(+504) 9452-3409 </>
      </span>
      
      </div>
      
      <div className="" id="iws54s">
        
      <span className="" id="">
        
      </span>
      
      <span className="" id="">
        
      </span>
      
      <span className="" id="i9drhg">
        <>(+504) 3292-8788</>
      </span>
      
      </div>
      
      </div>
      
      </div>
      
      <div id="ips2" className="">
      
      <img
        className=""
        id="ismeq"
        src="https://assetsprojects.s3.amazonaws.com/404ofwim56xoug0.png"
        alt="undefined"
      />
      
      <div id="ifvvzp" className="">
      
      <a
        target=""
        className=""
        id="inedox"
        href="/"
        type="button"
      >
        
    <div id="iclrrs" className="">
    <>Inicio</>
    </div>
    
      </a>
      
      <a
        target=""
        className=""
        id="iacjt4"
        href="/sobrenosotros"
        type="button"
      >
        
    <div id="ivmnu1" className="">
    <>Sobre Nosotros</>
    </div>
    
      </a>
      
        <LoftyDropdownComponent
          id="id2m4c"
          className="gjs-dropdown-menu-container "
          childrenShow={
            <>
              <div id="iu5tfy" className="gjs-dropdown-menu-trigger ">

      <span className="" id="i0irec">
        <>Inmuebles</>
      </span>
      </div>

            </>
          }
          childrenHover={
            <>
              <div id="i9izru" className="gjs-dropdown-menu-content " style={{display: 'block'}}>

        <a
          target=""
          className=""
          id="ii7y2k"
          href={`/inmueblesenrenta`}
        >
          
    <div id="imgix8" className="">
    <>En Renta</>
    </div>
    
        </a>
        
        <a
          target=""
          className=""
          id="irtuh9"
          href={`/inmueblesenventa`}
        >
          
    <div id="iq9u96" className="">
    <>En Venta</>
    </div>
    
        </a>
        </div>

            </>
          }
        />
        
      <a
        target=""
        className=""
        id="ih0w28"
        href="/contacto"
        type="button"
      >
        
    <div id="i89xkj" className="">
    <>Contacto</>
    </div>
    
      </a>
      
      </div>
      
      <div id="icq3pj" className="">
      
      <div id="" className="contentwrapperanimated ">
      
      <div id="" className="container_animated ">
      
      <label id="" className="menu__btn ">
      
      <span className="span_before " id="">
        
      </span>
      
      <span className="span_middle " id="">
        
      </span>
      
      <span className="span_after " id="">
        
      </span>
      
      </label>
      
      <label id="" className="menu__close__btn ">
      
      <span className="span__close__left " id="">
        
      </span>
      
      <span className="span__close__right " id="">
        
      </span>
      
      </label>
      
      <ul id="" className="menu__box ">
        
      <li className="linkshref " id="">
        
      <a
        target=""
        className="menu__item "
        id=""
        href="/"
        type=""
      >
        <>Inicio</>
      </a>
      
      </li>
      
      <li className="linkshref " id="">
        
      <a
        target=""
        className="menu__item "
        id=""
        href="/sobrenosotros"
        type=""
      >
        <>Sobre Nosotros</>
      </a>
      
      </li>
      
      <li className="linkshref " id="">
        
      <a
        target=""
        className="menu__item "
        id=""
        href="/inmueblesenrenta"
        type=""
      >
        <>Inmuebles en Renta</>
      </a>
      
      </li>
      
      <li className="linkshref " id="">
        
      <a
        target=""
        className="menu__item "
        id=""
        href="/inmueblesenventa"
        type=""
      >
        <>Inmuebles en Venta</>
      </a>
      
      </li>
      
      <li className="linkshref " id="">
        
      <a
        target=""
        className="menu__item "
        id=""
        href="/contacto"
        type=""
      >
        <>Contacto</>
      </a>
      
      </li>
      
      </ul>
      
      </div>
      
      </div>
      
      </div>
      
      </div>
      
      <div id="ica1a1" className="">
      
        <div id="ib5nvf" className="">
          
            <div>
              <LoftyCarousel
                responsive={{
                  superLargeDesktop: {
                    breakpoint: {max: 4000, min: 3000},
                    items: 1,
                  },
                  desktop: {
                    breakpoint: {max: 3000, min: 1024},
                    items: 1,
                  },
                  tablet: {
                    breakpoint: {max: 1024, min: 464},
                    items: 1,
                  },
                  mobile: {
                    breakpoint: {max: 464, min: 0},
                    items: 1,
                  },
                }}
                infinite
                autoPlay
              >
                {
                  loftyres_67c86a7fa9c8dc86c6729880_component_ib5nvf.map((loftyitem_67c86a7fa9c8dc86c6729880_component_ib5nvf) => (
                    <div key={loftyitem_67c86a7fa9c8dc86c6729880_component_ib5nvf._id} className="" id="i7jpl1">
                      
      <div id="iinfgd" className="">
      
        <img
          className=""
          id="id7pr8"
          alt=""
          src={loftyitem_67c86a7fa9c8dc86c6729880_component_ib5nvf.loftyUrl}
        />
        
      </div>
      
                    </div>
                  ))
                }
              </LoftyCarousel>
            </div>
            
        </div>
        
      </div>
      
      <div id="ipvnvk" className="">
      
      <div id="i1k4cl" className="">
      
      <div id="izrwft" className="">
      
        <div id="iwwfyt" className="">
        
      <div id="iy89cx" className="">
      
      <div id="imi3ki" className="">
      
      <div id="ici55c" className="">
      
      </div>
      
            <div id="ii4aqi" className="">
              {
                  loftyendpoint_67c87871a9c8dc86c6729cbc?.ventaam2kf && (
                    <div style={{display: 'block'}} className="" id="iry28k">
                      
      <div className="" id="ifkhr1">
        <>En Venta</>
      </div>
      
                    </div>
                  )
                }
                {
                  !loftyendpoint_67c87871a9c8dc86c6729cbc?.ventaam2kf && (
                    <div style={{display: 'block'}} className="" id="i841c9">
                      
      <div className="" id="it75dw">
        <>En Renta</>
      </div>
      
                    </div>
                  )
                }
            </div>
            
      </div>
      
      </div>
      
      <div className="label " id="iixynp">
        <>Titulo</>
      </div>
      
        <div className="" id="ibtftt">
          
          <div className="" id="">
            {loftyendpoint_67c87871a9c8dc86c6729cbc?.titulop4an9}
          </div>
          
        </div>
        
      <div className="label " id="ia6m4u">
        <>Descripción</>
      </div>
      
        <div className="" id="iz9sfr">
          
          <div className="" id="">
            {loftyendpoint_67c87871a9c8dc86c6729cbc?.descripcin3cpj8}
          </div>
          
        </div>
        
      <div className="label " id="iufwz2">
        <>Precio</>
      </div>
      
      <div id="i8aogi" className="">
      
            <div id="iusf07" className="">
              {
                  loftyendpoint_67c87871a9c8dc86c6729cbc?.dolarpagr && (
                    <div style={{display: 'block'}} className="" id="iokz94">
                      
      <div className="" id="i260lg">
        
      </div>
      
                    </div>
                  )
                }
                {
                  !loftyendpoint_67c87871a9c8dc86c6729cbc?.dolarpagr && (
                    <div style={{display: 'block'}} className="" id="i3h992">
                      
      <div className="" id="itsvu6">
        <>HNL</>
      </div>
      
                    </div>
                  )
                }
            </div>
            
        <div className="" id="irhoq2">
          
            <div className="" id="">
              {parseFloat(loftyendpoint_67c87871a9c8dc86c6729cbc?.preciobd4vvk).toLocaleString('en-US', {minimumFractionDigits: 2})}
            </div>
            
        </div>
        
      </div>
      
      <div className="label " id="ia1weo">
        <>Dirección</>
      </div>
      
        <div className="" id="igapq2">
          
          <div className="" id="">
            {loftyendpoint_67c87871a9c8dc86c6729cbc?.direccionnol9k}
          </div>
          
        </div>
        
      <div className="label " id="if1ctf">
        <>Telefono</>
      </div>
      
        <div className="" id="i0ssfo">
          
          <div className="" id="">
            {loftyendpoint_67c87871a9c8dc86c6729cbc?.telefonosq8fwf}
          </div>
          
        </div>
        
        </div>
        
        <div className="" id="ik23dk">
          
      <form
        id="idso0j"
        className=""
        onSubmit={async (e) => {
				e.preventDefault();
				try {
				} catch (error) {
					console.log(error);
					if (error.info) {
						alert(error.info);
					}
				}
			}}
		
      >
        
      <div id="i9sp52" className="">
      
      <div className="" id="ix7f9w">
        <>Solicitud del Inmueble en Venta</>
      </div>
      
      </div>
      
      <div id="ivf6fk" className="contenedor-input ">
      
      <br className="" id="" />
      
      <input
        name="nombre1kh6x"
        type="text"
        placeholder="Nombre"
        className="input "
        id="ibcefc"
      />
      
      </div>
      
      <div id="i78csf" className="contenedor-input ">
      
      <label id="iqvv3h" className="">
      <>Teléfono</>
      </label>
      
      <br className="" id="" />
      
      <input
        name="telefonoarmao"
        type="text"
        placeholder="Teléfono"
        className="input "
        id="i77mgw"
      />
      
      </div>
      
      <div id="i6jh97" className="contenedor-input ">
      
      <label id="" className="">
      <>Correo Electrónico</>
      </label>
      
      <br className="" id="" />
      
      <input
        name="correoelectrnico4zrcqk"
        type="text"
        placeholder="Correo Electrónico"
        className="input "
        id="iys72e"
      />
      
      </div>
      
    <div id="isfbxd" className="contenedor-input ">
    
      <label id="" className="">
      <>Mensaje</>
      </label>
      
      <br className="" id="" />
      
      <textarea name="mensaje7qeni" className="input " id="itmncx">
        
      </textarea>
      
    </div>
    
      <button
        type="submit"
        name=""
        id="icrmnb"
        className=""
        
      >
      
      <div id="iswtmr" className="">
      <>Enviar</>
      </div>
      
      </button>
      
      </form>
      
        </div>
        
      </div>
      
      </div>
      
      </div>
      
      <div id="ikukgf" className="">
      
      <div id="i1qiq6" className="">
      
      </div>
      
      <div id="i28lhh" className="">
      
      <div id="inehij" className="">
      
      <div className="" id="i2p8fx">
        
      <span className="" id="">
        
      </span>
      
      <span className="" id="">
        
      </span>
      
      <span className="" id="i6lug4">
        <>¿Planea arrendar o vender su inmueble?</>
      </span>
      
      </div>
      
      </div>
      
        <a
          target=""
          className=""
          id="ivq6og"
          href="/contacto"
        >
          
      <span className="" id="inw7ed">
        <>Contáctanos</>
      </span>
      
        </a>
        
      </div>
      
      </div>
      
      <div id="il4d9o" className="">
      
      <div id="ioigc7" className="">
      
      <div id="ir2su1" className="">
      
      <img
        className=""
        id="imr6xn"
        src="https://assetsprojects.s3.amazonaws.com/404ofwim56z3fz2.png"
        alt="undefined"
      />
      
      </div>
      
      <div id="iip0hj" className="">
      
      <div id="icdzzf" className="">
      
      <div id="itmdc" className="">
      
      <a
        target=""
        className=""
        id="i2aqf"
        href="/"
        type="button"
      >
        
    <div id="i2g1w" className="">
    <>Inicio</>
    </div>
    
      </a>
      
      <a
        target=""
        className=""
        id="iwu1w"
        href="/sobrenosotros"
        type="button"
      >
        
    <div id="ib1qi" className="">
    <>Sobre Nosotros</>
    </div>
    
      </a>
      
      <a
        target=""
        className=""
        id="ig1at"
        href="/contacto"
        type="button"
      >
        
    <div id="isq53" className="">
    <>Contacto</>
    </div>
    
      </a>
      
      </div>
      
      <div id="inxorr" className="">
      
      <img
        className=""
        id="iib493"
        src="https://assetsprojects.s3.amazonaws.com/404ofwim56z589z.png"
        alt="undefined"
      />
      
      </div>
      
      <div className="" id="i9jwhn">
        
      <span className="" id="">
        
      </span>
      
      <span className="" id="">
        
      </span>
      
      <span className="" id="ilrddl">
        <>Teléfono: +504 33445633 
Correo electrónico: informacion@grupodor.com 
Dirección: Colonia Universidad, 24 calle, 9 avenida, Plaza Bulevares, San Pedro Sula, Cortés, Honduras C.A. </>
      </span>
      
      </div>
      
      <div id="ikrieu" className="">
      
        <a
          target="_blank"
          className=""
          id="iugvxb"
          href="https://www.facebook.com/DORInmobiliariaHN/?_rdr"
        >
          
      <span className="" id="ifk2kr">
        <>Facebook</>
      </span>
      
        </a>
        
        <a
          target="_blank"
          className=""
          id="iewo54"
          href="https://www.instagram.com/dorinmobiliaria"
        >
          
      <span className="" id="ig11q1">
        <>Instagram</>
      </span>
      
        </a>
        
        <a
          target="_blank"
          className=""
          id="ixgr5i"
          href="https://www.linkedin.com/company/dor-inmobiliaria/"
        >
          
      <span className="" id="iz2xzh">
        <>LinkedIn</>
      </span>
      
        </a>
        
      </div>
      
      </div>
      
      </div>
      
      </div>
      
      <div id="imier2" className="">
      
      <div id="i50ldy" className="">
      
      </div>
      
      <div id="igphyo" className="">
      
      <div className="" id="i1gmf4">
        
      <span className="" id="">
        
      </span>
      
      <span className="" id="">
        
      </span>
      
      <span className="" id="iy1e52">
        <>DOR © 2024. Todos los derechos reservados</>
      </span>
      
      </div>
      
      <div className="" id="ids74n">
        
      <span className="" id="">
        
      </span>
      
      <span className="" id="">
        
      </span>
      
      <span className="" id="izx0i8">
        <>Términos de uso</>
      </span>
      
      </div>
      
      <div className="" id="i6pgi9">
        
      <span className="" id="">
        
      </span>
      
      <span className="" id="">
        
      </span>
      
      <span className="" id="itfy23">
        <>Políticas de privaciad</>
      </span>
      
      </div>
      
      </div>
      
      </div>
      
      </div>
      
      </div>
      
</div>
  );
}

const mapStateToProps = (state) => state.auth;

const mapDispatchToProps = (dispatch) => ({
 addLoftyTokenApp: (data) => dispatch(addLoftyToken(data)),
 deleteLoftytokenApp: () => dispatch(deleteLoftytoken()),
});


export default connect(mapStateToProps, mapDispatchToProps)(Pvisualizacininmuebleqn2py);
  